import { mapEdgesToNodes } from "../../base/utils";

export const CategoryTransformer = (category = {}, level) => {
  if (!category) return null;
  let sub_categories = mapEdgesToNodes(category?.children?.edges).map((child) =>
    CategoryTransformer(child)
  );
  return {
    id: category?.id,
    name: category?.name,
    slug: category?.slug,  
    parent_id: category?.parent?.id,
    image: category?.backgroundImage?.url,
    products_count: category?.products?.totalCount || 0,
    metadata: category?.metadata,
    sub_categories:
      level >= 1
        ? [
            {
              name: "All",
              id: category?.id,
              slug: category?.slug, 
              parent_id: category?.parent?.id,
              image: category?.backgroundImage?.url,
              products_count: category?.products?.totalCount || 0,
              sub_categories: [],
              translation: "الجميع",
            },
            ...sub_categories,
          ]
        : sub_categories,
    translation: category?.translation?.name,
  };
};

export const CategoryFilterAttributesTransformer = (attribute) => {
  const metadata = attribute.metadata || [];
  const filterMetadata = metadata.find((item) => item.key === "filter");
  if (filterMetadata && filterMetadata.value === "false") {
    return null;
  }
  if (!attribute) return null;
  return {
    id: attribute?.id,
    label: attribute?.name,
    translation: attribute.translation?.name,
    slug: attribute?.slug,
    active: false,
    list: attribute?.choices
      ? mapEdgesToNodes(attribute?.choices?.edges).map((choice) =>
          CategoryFilterAttributesTransformer({ ...choice, active: false })
        )
      : [],
  };
};
